module.exports = __webpack_public_path__ + "static/media/org_person_name.dc8c106e.svg";